import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCurrentGoogleOwner } from "../api/AppLinkApi";

const GoogleUserConnection = ({
  onValidityChange,
}: {
  onValidityChange?: (valid: boolean) => void;
}) => {
  const { t } = useTranslation();
  const [connectedUser, setConnectedUser] = useState({
    picture: "",
    name: "",
    email: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const hasError = errorMessage != "";

  useEffect(() => {
    getCurrentGoogleOwner()
      .then((data) => {
        setConnectedUser(data);
        onValidityChange?.(true);
      })
      .catch(() => {
        setErrorMessage(t("Google account is not connected."));
        onValidityChange?.(false);
      });
  }, [t]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderConnectedUserAvatar = () => {
    return (
      <span className="inline-block h-8 w-8 overflow-hidden rounded-full bg-gray-100">
        <svg className="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      </span>
    );
  };

  const renderUserInformation = () => {
    if (hasError) {
      return (
        <div>
          <div>{t("Anonymous")}</div>
          <div>{connectedUser.email}</div>
        </div>
      );
    }
    return (
      <div>
        <div>{connectedUser.name}</div>
        <div>{connectedUser.email}</div>
      </div>
    );
  };

  return (
    <div className={"flex space-x-2 text-sm items-center"}>
      {renderConnectedUserAvatar()}
      {renderUserInformation()}
    </div>
  );
};

export default GoogleUserConnection;
